import React, { useState } from "react";
import { CheckIcon, CopyIcon } from "lucide-react";
interface CopyButtonProps {
  text: string;
  label: string;
  tone?: "light" | "dark";
  size?: "md" | "sm";
}
export function CopyButton({
  text,
  label,
  tone = "light",
  size = "md"
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };
  const styles = tone === "dark" ? "border-white/20 text-white hover:bg-white/10" : "border-ink/15 bg-surface text-ink hover:bg-paper";
  const sizing = size === "sm" ? "gap-1.5 rounded-lg px-2.5 py-1.5 text-xs" : "gap-2 rounded-xl px-4 py-2.5 text-sm";
  const icon = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  return <button type="button" onClick={handleCopy} className={`inline-flex items-center whitespace-nowrap border font-semibold transition-[transform,background-color] duration-150 ease-out active:scale-[0.97] ${sizing} ${styles}`} data-id="element-31" data-mp="3rle943y26i9">
      {copied ? <CheckIcon className={`${icon} text-brgreen`} aria-hidden="true" data-id="element-32" data-mp="32x0rk2taplle" /> : <CopyIcon className={icon} aria-hidden="true" data-id="element-33" data-mp="2y3xz5y098i6s" />}
      {copied ? "Copied" : label}
    </button>;
}